import React from "react";
import { Link } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import Rectangle from "../../assests/office.webp";
import "./hero.css";

const Hero = () => (
  <section className="site-hero" aria-labelledby="hero-heading">
    <div className="site-container site-hero-grid">
      <div className="site-hero-copy">
        <p className="site-eyebrow"><span className="site-status-dot" /> Din redovisningsbyrå i Stockholm</p>
        <h1 id="hero-heading">Mer tid för<br />ditt <em>företag.</em></h1>
        <p className="site-hero-intro">Vi tar hand om siffrorna, så att du kan fokusera på det du gör bäst. Personlig hjälp med bokföring, lön och redovisning.</p>
        <div className="site-hero-actions">
          <Link className="site-button" to="/#contact">Kontakta oss <ArrowForward fontSize="small" /></Link>
          <Link className="site-text-link" to="/#priser">Se paket & priser <span aria-hidden="true">↗</span></Link>
        </div>
        <div className="site-hero-details"><span>Fasta bokföringspaket</span><span>Personlig kontakt</span></div>
      </div>
      <div className="site-hero-visual">
        <img className="site-hero-photo" src={Rectangle} alt="Samarbete kring företagets ekonomi" width="1200" height="402" fetchpriority="high" />
        <div className="site-hero-caption"><span className="site-hero-caption-mark" aria-hidden="true">↗</span><div><strong>Din ekonomi. Vårt fokus.</strong><span>Från löpande bokföring till bokslut.</span></div></div>
        <span className="site-hero-image-label">En enklare ekonomisk vardag</span>
      </div>
    </div>
    <div className="site-container site-hero-bottom"><span>Trygghet i varje siffra.</span><Link to="/#services">Upptäck våra tjänster <span aria-hidden="true">↓</span></Link></div>
  </section>
);
export default Hero;
